import { PaymentGatewaySupported } from "@fitness-force/enum";

export interface PdfData {
    type: PdfType ;
    primaryId: number;
    secondaryId: number ;
    numberPrefix: string ;
    status: string ;
    clientId: number;
    tenantId:number;
}

export enum PdfType
{
    Invoice,
    Payment,
    SalesReturn,
    Refund,
    Retail
}

export interface RefundData {
    refundType: RefundType ;
    primaryId: number;
    tenantId:number;
    clientId:number;
    amount: number;
    isOnline:boolean;
    paymentGateway ?:PaymentGatewaySupported | null;
    paymentMethods:any
}

export enum RefundType
{
    Payment,
    CreditBalance
}


export interface NotificationError {
    channel: string
    client_id: number
    staff_id: number
    success: boolean
    error: Error
  }
  
  export interface Error {
    severity: string
    errorCode: string
    errorMessage: string
    identifier: string
    helptext: string
    jsonObject: string
  }

  export interface TimeZone {
    Id:string;
    DisplayName:string;
    StandardName:string;
    DaylightName:string;
    BaseUtcOffset:string;
    IanaTimeZone:string;
  }


  export interface SourceStats {
      source: Source[]
      channel: string;
      total_sources: number;
  }

  export interface Source {
    source: string;
    count: number;
  }